import React from "react";
import editLight from "assets/images/manageTeam/editLight.svg";
import editDark from "assets/images/manageTeam/editDark.svg";
import deleteLight from "assets/images/manageTeam/deleteLight.svg";
import deleteDark from "assets/images/manageTeam/deleteDark.svg";
import showDark from "assets/images/manageTeam/show.svg";
import showLight from "assets/images/manageTeam/showdark.svg";
import "./teamTable.scss";
import useTheme from "hooks/observer";
import useScreenMobile from "hooks/useScreen";
import Tooltip from "components/Tooltip/index";

function TeamTable({ teams, handleEditTeam, handleshowDelete }) {
  const theme = useTheme();
  const isMobile = useScreenMobile({ size: 992 });
  const isMobileStrict = useScreenMobile({ size: 768 });
  const [activeMenu, setActiveMenu] = React.useState(null);

  const maxVisibleOperations = 1;

  const editIcon = theme === "light" ? editLight : editDark;
  const deleteIcon = theme === "light" ? deleteLight : deleteDark;
  const showIcon = theme === "light" ? showLight : showDark;

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        activeMenu !== null &&
        !event.target.closest(".mobile-action-menu-container")
      ) {
        setActiveMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [activeMenu]);

  // Comment: Teams data is passed from ManageTeam, which will fetch from API in the future
  function truncateItems(items, maxVisible) {
    if (!Array.isArray(items)) return [];
    const visible = items.slice(0, maxVisible);
    const remainingData = items.slice(maxVisible);
    const remaining = remainingData.length;
    return { visible, remaining, remainingData };
  }

  return (
    <div className="TeamTable">
      {isMobileStrict ? (
        <table className="TeamTableMobile">
          <thead>
            <tr>
              <th className="col-team">Team Name</th>
              <th className="col-actions">Actions</th>
            </tr>
          </thead>
          <tbody>
            {teams.map((team, index) => (
              <tr key={index}>
                <td className="col-team TeamName">
                  <p>{team.roles}</p>
                </td>
                <td className="col-actions Actions">
                  <div className="mobile-action-menu-container">
                    <button
                      className="three-dot-btn"
                      onClick={() =>
                        setActiveMenu(activeMenu === index ? null : index)
                      }
                    >
                      ⋮
                    </button>
                    {activeMenu === index && (
                      <div
                        className={`mobile-action-menu ${index === teams.length - 1 && teams.length > 1
                          ? "open-upward"
                          : ""
                          }`}
                      >
                        <div className="menu-item operations-label">
                          <p className="label-title">
                            Roles ({team.operations.length})
                          </p>
                          {team.operations.length > 0 && (
                            <p className="operations-list-text">
                              {team.operations.join(", ")}
                            </p>
                          )}
                        </div>
                        <div
                          className="menu-item"
                          onClick={() => {
                            handleEditTeam(index);
                            setActiveMenu(null);
                          }}
                        >
                          <img src={showIcon} alt="view" />
                          Roles
                        </div>
                        <div
                          className="menu-item"
                          onClick={() => {
                            handleEditTeam(index);
                            setActiveMenu(null);
                          }}
                        >
                          <img src={editIcon} alt="edit" />
                          Edit
                        </div>
                        <div
                          className="menu-item"
                          onClick={() => {
                            handleshowDelete(index);
                            setActiveMenu(null);
                          }}
                        >
                          <img src={deleteIcon} alt="delete" />
                          Delete
                        </div>
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : isMobile ? (
        <div className="mobileTeamsContainer">
          {teams.map((team, index) => {
            const {
              visible: visibleOperations,
              remaining: operationOverflow,
              remainingData: remainingOperations
            } = truncateItems(team.operations, maxVisibleOperations);

            return (
              <div key={index} className="mobileTeamCard">
                <div className="mobileTeamHeader">
                  <h3 className="mobileTeamName">{team.roles}</h3>
                  <div className="mobileTeamActions">
                    <img
                      src={editIcon}
                      alt="Edit team"
                      role="button"
                      aria-label={`Edit ${team.roles} team`}
                      onClick={() => handleEditTeam(index)}
                      style={{ cursor: "pointer" }}
                    />

                    <img
                      src={deleteIcon}
                      alt="Delete team"
                      role="button"
                      aria-label={`Delete ${team.roles} team`}
                      onClick={() => handleshowDelete(index)} // Changed from handleShowDelete
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                </div>


                <div className="mobileTeamSection">
                  <div className="mobileSectionLabel">Operations</div>
                  <div className="mobileTeamContainer">
                    {visibleOperations.map((operation, idx) => (
                      <div key={idx} className="mobileTeamItem">
                        <p>{operation}</p>
                      </div>
                    ))}
                    {operationOverflow > 0 && (
                      <Tooltip
                        text={remainingOperations.join(", ")}
                        mockClass={"manageTable"}
                        position="top"
                      >
                        <div className="mobileExtraCount">
                          <p>+{operationOverflow}</p>
                        </div>
                      </Tooltip>
                    )}
                    {team.operations.length === 0 && (
                      <div className="mobileTeamItem">
                        <p>No operations added</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="TeamTableWrapper">
          <table className="TeamTableHead">
            <colgroup>
              <col style={{ width: "30%" }} />
              <col style={{ width: "40%" }} />
              <col style={{ width: "30%" }} />
            </colgroup>
            <thead>
              <tr>
                <th>Team Name</th>
                <th>Roles</th>
                <th className="col-actions">Actions</th>
              </tr>
            </thead>
          </table>

          <div className="TeamTableBodyWrapper">
            <table className="TeamTableBody">
              <colgroup>
                <col style={{ width: "30%" }} />
                <col style={{ width: "40%" }} />
                <col style={{ width: "30%" }} />
              </colgroup>
              <tbody>
                {teams.map((team, index) => {
                  const {
                    visible: visibleOperations,
                    remaining: operationOverflow,
                    remainingData: remainingOperations
                  } = truncateItems(team.operations, maxVisibleOperations);

                  return (
                    <tr key={index}>
                      <td className="TeamName">
                        {" "}
                        <p>{team.roles}</p>
                      </td>

                      <td className="Operations">
                        <div className="OperationsContainer">
                          {visibleOperations.map((operation, idx) => (
                            <div key={idx} className="OperationItem">
                              <p>{operation}</p>
                            </div>
                          ))}
                          {operationOverflow > 0 && (
                            <div className="extraCount">
                              <p>{`${remainingOperations.join(", ")} + ${operationOverflow}`}</p>
                            </div>
                          )}
                          {team.operations.length === 0 && (
                            <div className="OperationItem">
                              No operations added
                            </div>
                          )}
                        </div>
                      </td>

                      <td className="Actions">
                        <div className="ActionsContainer">
                          <span data-tooltip="Edit" className="action-icon-wrap">
                            <img
                              src={editIcon}
                              alt="Edit team"
                              role="button"
                              aria-label={`Edit ${team.roles} team`}
                              onClick={() => handleEditTeam(index)}
                              style={{ cursor: "pointer" }}
                            />
                          </span>

                          <span data-tooltip="Trash" className="action-icon-wrap">
                            <img
                              src={deleteIcon}
                              alt="Delete team"
                              role="button"
                              aria-label={`Delete ${team.roles} team`}
                              onClick={() => handleshowDelete(index)} // Changed from handleShowDelete
                              style={{ cursor: "pointer" }}
                            />
                          </span>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default TeamTable;